export default "__VITE_ASSET__HyG81QDU__"